import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
//import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddpartyComponent } from './addparty/addparty.component';
@Component({
  selector: 'app-party',
  templateUrl: './party.component.html',
  styleUrls: ['./party.component.css']
})
export class PartyComponent implements OnInit, AfterViewInit, OnDestroy {


  partyColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "";

  ptype: String = "";

  searchtxt: any = "";
  columnDefs = [

    { headerName: 'Party', field: 'partyname' },
    { headerName: 'Mobile', field: 'mobileno'},
    { headerName: 'Address', field: 'address1' },
    { headerName: 'Locality', field: 'locality'},
    { headerName: 'EntryOn', field: 'createdon',type:"datetime"},
    { headerName: 'Status', field: 'activestatus', type: 'activestatus' },
    
    // { headerName: 'Party', field: 'partyname', colwidth: '10%', colcls: "tbtx" },
    // { headerName: 'Mobile', field: 'mobileno', colwidth: '10%', colcls: "tbtx" },
    // { headerName: 'Address', field: 'address1', colwidth: '250px', colcls: "tbtx" },
    // { headerName: 'Locality', field: 'locality', colwidth: '250px', colcls: "tbtx" },
    // { headerName: 'Status', field: 'activestatus' ,type:'activestatus'},
  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
  };

  constructor(private appService: DhukanDataService, public router: Router, private route: ActivatedRoute, private productFindService: NgbModal,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) {
    this.route.queryParams.subscribe(params => {
      if (params.ptype !== undefined) {
        this.ptype = params.ptype
      }

      if (this.ptype === "C") {
        this.formname = "Customer"
      }
      else if (this.ptype === "S") {
        this.formname = "Supplier"
      }
      this.fnSetTable();
      // this.fnOnInitForm();      
    });
    this.fnServiceChanges();

  }
  fnSetTable() {
    for (let row of this.columnDefs) {
      if (this.ptype === "C") {
        if (row.field === "partyname") {
          row.headerName = "Customer"
        }
      }
      else if (this.ptype === "S") {
        if (row.field === "partyname") {
          row.headerName = "Supplier"
        }
      }
    
    }
  }


  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetParty();
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    
  }

 

  fngetParty() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'partyid': 0,
      'ptype': this.ptype,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.partyColl = res.json().result;

            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }
  fnAddParty() {
    try {
      const modalRef = this.productFindService.open(AddpartyComponent, { size: <any>'l', backdrop: 'static',keyboard: false });

      modalRef.componentInstance.ptype = this.ptype

      if (modalRef.componentInstance.ptype === 'C') {
        modalRef.componentInstance.formname = 'Customer'
      }
      else if (modalRef.componentInstance.ptype === 'S') {
        modalRef.componentInstance.formname = 'Supplier'
      }
      modalRef.componentInstance.ngOnInit();

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetParty();

      });


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

 
  fnViewParty(pBO) {
    try {
      var deptid = pBO.partyid
      if(this.ptype==='C'){
        this.formname='Customer'
      }
      else if(this.ptype==='S'){
        this.formname='Supplier'
      }
      if(this){}
        let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': deptid,
          'ptype':this.ptype
       
        }
        }
  
      this.router.navigate(['/ViewParty'], navigationExtras);
    }catch(ex){
      this.fnShowErrorMsg(ex);
      this.fngetParty();
    }
  }

  fnEditParty(pBO) {
    try {
      var deptid = pBO.partyid

      const modalRef = this.productFindService.open(AddpartyComponent, { size: <any>'l', backdrop: 'static', keyboard: false });
      modalRef.componentInstance.partyid = deptid;
      modalRef.componentInstance.ptype = this.ptype
      if (modalRef.componentInstance.ptype === 'C') {
        modalRef.componentInstance.formname = 'Customer'
      }
      else if (modalRef.componentInstance.ptype === 'S') {
        modalRef.componentInstance.formname = 'Supplier'
      }
      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetParty();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  public fnDeleteConfirm(pBO) {
    try {
      var deptid = pBO.partyid
      var _msg = ''
      if (this.ptype === 'C') {
        _msg = ('Do you  want to delete Customer?')
      }
      else if (this.ptype === 'S') {
        _msg = ('Do you  want to delete Supplier?')
      }
      this.confirmationDialogService.confirm('Confirm..', _msg)
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteParty(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteParty(deptid) {
    var data = {
      'partyid': deptid,
    }
    this.appService.fnDeleteParty(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {

            if (this.ptype === 'C') {
              this.toastr.success('', " The Customer has been deleted successfully.");
            }
            else if (this.ptype === 'S') {
              this.toastr.success('', " The Supplier has been deleted successfully.");
            }
            this.fnInsertActivityLog('DELETE', deptid, this.fnGetDescription(deptid));

            this.fngetParty();
          } else {
            this.toastr.error('', res.json().err_field);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'Partylist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };

  }


  private fnSetDataTable() {

  }


  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

 

  fnGetDescription(id) {
    const index = this.partyColl.findIndex(sku => sku.partyid === id);

    if (index) {
      return this.partyColl[index].Partyid;
    }
    else {
      return "";
    }

  }
  public fnSearchDatatable(value) {



  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }




}
